import { ArrowLeftCircle, ArrowRightCircle } from "lucide-react";
import type { ReactNode } from "react";
import type { Locale } from "./homepage-seo.ts";
import { strategyBuilderT } from "./strategy-builder-i18n.ts";
import { strategyConditionSummary } from "./strategy-rule-summary.ts";
import type { StrategyRuleCondition, StrategyRuleDSL } from "./strategy-builder.ts";
import "./strategy-builder.css";

export function StrategyRuleSummary({
  locale,
  dsl,
  entryOnly = false,
}: {
  locale: Locale;
  dsl: StrategyRuleDSL;
  entryOnly?: boolean;
}) {
  return (
    <section className="strategy-rule-summary" aria-label={strategyBuilderT(locale, "title")}>
      <RuleSummaryGroup
        locale={locale}
        title={strategyBuilderT(locale, "entryRules")}
        match={dsl.entry.match}
        conditions={dsl.entry.conditions}
        icon={<ArrowRightCircle size={17} aria-hidden="true" />}
      />
      {!entryOnly && <RuleSummaryGroup
        locale={locale}
        title={strategyBuilderT(locale, "exitRules")}
        match={dsl.exit.match}
        conditions={dsl.exit.conditions}
        icon={<ArrowLeftCircle size={17} aria-hidden="true" />}
      />}
    </section>
  );
}

function RuleSummaryGroup({
  locale,
  title,
  match,
  conditions,
  icon,
}: {
  locale: Locale;
  title: string;
  match: "all" | "any";
  conditions: StrategyRuleCondition[];
  icon: ReactNode;
}) {
  return (
    <article className="strategy-rule-summary__group">
      <header>
        <strong>{icon}{title}</strong>
        <span>{strategyBuilderT(locale, match === "all" ? "matchAll" : "matchAny")}</span>
      </header>
      <ol>
        {conditions.map((condition) => (
          <li key={condition.id}>{strategyConditionSummary(locale, condition)}</li>
        ))}
      </ol>
    </article>
  );
}
